var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmitFn($event)
        }
      }
    },
    [
      _c(
        "b-form-row",
        [
          _c(
            "b-col",
            { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
            [
              _c("label", { staticClass: "w-100 text-right" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.addressForm.label.street")) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-3", attrs: { cols: "9" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    state: _vm.$v.address.street.$error ? false : null,
                    "invalid-feedback": _vm.$t("error.addressForm.street")
                  }
                },
                [
                  _c("b-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      state: _vm.$v.address.street.$error ? false : null
                    },
                    on: {
                      changed: function($event) {
                        _vm.$v.address.street.$touch()
                      }
                    },
                    model: {
                      value: _vm.address.street,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "street", $$v)
                      },
                      expression: "address.street"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
            [
              _c("label", { staticClass: "w-100 text-right" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.addressForm.label.streetNumber")) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-3", attrs: { cols: "9" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    state: _vm.$v.address.streetNumber.$error ? false : null,
                    "invalid-feedback": _vm.$t("error.addressForm.streetNumber")
                  }
                },
                [
                  _c("b-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      state: _vm.$v.address.streetNumber.$error ? false : null
                    },
                    on: {
                      changed: function($event) {
                        _vm.$v.address.streetNumber.$touch()
                      }
                    },
                    model: {
                      value: _vm.address.streetNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "streetNumber", $$v)
                      },
                      expression: "address.streetNumber"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
            [
              _c("label", { staticClass: "w-100 text-right" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.addressForm.label.additionalAddress"))
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-3", attrs: { cols: "9" } },
            [
              _c(
                "b-form-group",
                [
                  _c("b-input", {
                    staticClass: "rounded-0",
                    model: {
                      value: _vm.address.additionalAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "additionalAddress", $$v)
                      },
                      expression: "address.additionalAddress"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
            [
              _c("label", { staticClass: "w-100 text-right" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.addressForm.label.postalCode")) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-3", attrs: { cols: "9" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    state: _vm.$v.address.postalCode.$error ? false : null,
                    "invalid-feedback": _vm.$t("error.addressForm.postalCode")
                  }
                },
                [
                  _c("b-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      state: _vm.$v.address.postalCode.$error ? false : null
                    },
                    on: {
                      changed: function($event) {
                        _vm.$v.address.postalCode.$touch()
                      }
                    },
                    model: {
                      value: _vm.address.postalCode,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "postalCode", $$v)
                      },
                      expression: "address.postalCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
            [
              _c("label", { staticClass: "w-100 text-right" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.addressForm.label.city")) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-3", attrs: { cols: "9" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    state: _vm.$v.address.city.$error ? false : null,
                    "invalid-feedback": _vm.$t("error.addressForm.city")
                  }
                },
                [
                  _c("b-input", {
                    staticClass: "rounded-0",
                    attrs: { state: _vm.$v.address.city.$error ? false : null },
                    on: {
                      changed: function($event) {
                        _vm.$v.address.city.$touch()
                      }
                    },
                    model: {
                      value: _vm.address.city,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "city", $$v)
                      },
                      expression: "address.city"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "col-form-label px-3", attrs: { cols: "3" } },
            [
              _c("label", { staticClass: "w-100 text-right" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.addressForm.label.country")) +
                    "\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-3", attrs: { cols: "9" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    state: _vm.$v.address.country.$error ? false : null,
                    "invalid-feedback": _vm.$t("error.addressForm.country")
                  }
                },
                [
                  _c("b-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      state: _vm.$v.address.country.$error ? false : null
                    },
                    on: {
                      changed: function($event) {
                        _vm.$v.address.country.$touch()
                      }
                    },
                    model: {
                      value: _vm.address.country,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "country", $$v)
                      },
                      expression: "address.country"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        [
          _c(
            "b-col",
            { staticClass: "col-form-label px-3 ", attrs: { offset: "3" } },
            [
              _c("div", { staticClass: "requieredFields text-right" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "message.contractPartnerDetails.label.requiredFields"
                      )
                    )
                  }
                })
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e360686", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e360686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address/AddressForm.vue
// module id = xesk
// module chunks = 1